import { NextPage } from 'next';
import { GetServerSideProps } from 'next';
import ReadDetail from '@/components/screens/read-detail/ReadDetail';
import { API_URL } from '@/helpers/variables';
import { IBookDetailData } from '@/interfaces/bookDetail.interface';
import { IReviews } from '@/interfaces/reviews.interface';
import { IRead } from '@/interfaces/read.interface';
import { MENU_API } from '@/helpers/variables';
import { IMenuData } from '@/interfaces/menu.interface';

interface IReviewsPage extends IMenuData {
  book: IBookDetailData;
  read: IRead;
  reviews: IReviews;
}

const ReadPage: NextPage<IReviewsPage> = ({ book, read, reviews, menuNew, menuGenres }) => {
  return <ReadDetail book={book} read={read} reviews={reviews} menuNew={menuNew} menuGenres={menuGenres} />;
};

export const getServerSideProps: GetServerSideProps = async (context) => {
  const { id } = context.query;

  const bookRes = await fetch(`${API_URL}satellite/books/${id}`);
  const book = await bookRes.json();
  // Check Fetched Data Error
  if (!book.id || book.book.external_uid === undefined) {
    return {
      notFound: true,
    };
  }

  const readRes = await fetch(
    book.book.allow_full_free > 0
      ? `${API_URL}read-online?external_uid=${book.book.external_uid}&alias=${book.book.alias}&secret=J%3F_k.Y%40z!6K1h%3D4~mC4!Fx]%2CTXJUZyt]`
      : `${API_URL}read-online?external_id=${book.book.external_id}&secret=J%3F_k.Y%40z!6K1h%3D4~mC4!Fx]%2CTXJUZyt]`
  ).catch((e) => {
    console.warn(e);
    return null;
  });

  // Check Fetched Data Error
  if (readRes?.status === 500) {
    return {
      notFound: true,
    };
  }
  const read = await readRes?.json();

  const reviewsRes = await fetch(`${API_URL}satellite/reviews/?book_id=${id}&page=1&page_size=5`);
  const reviews = await reviewsRes.json();

  const [menuNewRes, menuGenresRes] = await Promise.all([fetch(`${MENU_API.news}`), fetch(`${MENU_API.genres}`)]);
  const [menuNew, menuGenres] = await Promise.all([menuNewRes.json(), menuGenresRes.json()]);

  return { props: { book, read, reviews, menuNew, menuGenres } };
};

export default ReadPage;
